import React from "react";
import reweavingThumbUrl from "../reweaving/assets/image/thumbnail.jpg";
import { ItemList } from "./component/itemList";

export function HomePage() {
  return (
    <div className="app-container">
      <main className="main-content">
        <ItemList
          items={[
            {
              href: "/reweaving",
              thumbnailSrc: reweavingThumbUrl,
              title: "REWEAVING",
              subtitle: "Algorithmic deconstruction & synthesis",
            },
          ]}
        />
      </main>
    </div>
  );
}

export default HomePage;
